import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Output, ChangeDetectorRef, HostListener } from "@angular/core";
import { PaymentAcquirerSearchCriteria } from "../payment-acquirer-search.model";
import { Select2Data } from "src/app/shared/ui/forms/inputs/oops-select2";
import { PaymentAcquirerSearchService } from "../payment-acquirer-search.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import * as _ from 'lodash';
import { Router } from "@angular/router";

@Component({
    selector: 'op-payment-acquirer-search-criteria',
    templateUrl: './payment-acquirer-search-criteria.component.html',
})
export class PaymentAcquirerSearchCriteriaComponent implements OnInit, OnDestroy, AfterViewInit {

    focusing = false
    criteria: PaymentAcquirerSearchCriteria = this.getDefaultCriteria()
    initSearch: boolean
    
    dropdownOption = {
        placeholder: '',
        allowClear: true,
        minimumResultsForSearch: -1,
    }

    statusOptionList: Select2Data[]

    private subscriptions: Subscription[]

    @Output() onSearch = new EventEmitter<PaymentAcquirerSearchCriteria>()
    @Output() onClear = new EventEmitter<never>()

    constructor(private paymentAcquirerSearchService: PaymentAcquirerSearchService,
        private cdr: ChangeDetectorRef,
        private router: Router) {
    }

    ngOnInit(): void {
        this.subscriptions = []
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.paymentAcquirerSearchService.callSearch$
                .pipe(
                    filter(flg => !!flg && !this.initSearch),
                )
                .subscribe(() => {
                    this.search()
                    this.initSearch = true

                    setTimeout(() => {
                        this.useLastCriteria()
                    }, 1000)
                })
        )

        this.subscriptions.push(
            this.paymentAcquirerSearchService.statusReferenceModels$.subscribe(response => {
                this.statusOptionList = response.map(r => new Select2Data(r.statusCode, r.displayName))
                this.cdr.markForCheck()
            })
        )
    }

    private useLastCriteria() {
        this.subscriptions.push(
            this.paymentAcquirerSearchService.criteria$
                .pipe(filter(f => !!f))
                .subscribe(dataMap => {
                    const currentTabId = this.router.url.split('/')[3]
                    const lastCriteria = dataMap.get(currentTabId);
                    if (!_.isEqual(lastCriteria, this.criteria)) {
                        if (lastCriteria) {
                            this.criteria = lastCriteria
                            this.search()
                        }
                    }
                })
        );
    }

    search(): void {
        this.onSearch.emit(this.criteria)
    }
    clear(): void {
        this.criteria = this.getDefaultCriteria()
        this.onClear.emit()
    }

    @HostListener("window:keydown", ["$event"])
    public keyDown(event) {
        const enterKeyCode = 13;
        switch (event.keyCode) {
            case enterKeyCode:
                this.search()
                break
        }
    }
    dataChange(value: any, controlName: string): void {
        this.criteria[controlName] = value
    }


    private getDefaultCriteria(): PaymentAcquirerSearchCriteria {
        return {
            statusCode: 'A'
        };
    }

}
